export function hexToRgba(hex, alpha = 1) {
    if (!hex || typeof hex !== 'string') return `rgba(0,0,0,${alpha})`;
    const a = Math.max(0, Math.min(1, Number(alpha)));

    // Support rgb()/rgba() inputs too (ColorPicker can emit non-hex in some cases)
    const s = hex.trim();
    if (/^rgba?\(/i.test(s)) {
        const nums = s
            .replace(/rgba?\(/i, '')
            .replace(')', '')
            .split(',')
            .map((x) => x.trim())
            .filter(Boolean);
        const r = Number(nums[0]);
        const g = Number(nums[1]);
        const b = Number(nums[2]);
        if ([r, g, b].some((n) => Number.isNaN(n))) return `rgba(0,0,0,${a})`;
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    }

    const raw = s.replace('#', '').trim();
    const normalized = raw.length === 3
        ? raw.split('').map((c) => c + c).join('')
        : raw;
    if (!/^[0-9a-fA-F]{6}$/.test(normalized)) return `rgba(0,0,0,${alpha})`;
    const r = parseInt(normalized.slice(0, 2), 16);
    const g = parseInt(normalized.slice(2, 4), 16);
    const b = parseInt(normalized.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export function hashStringToHsl(input) {
    const s = String(input || '');
    let hash = 0;
    for (let i = 0; i < s.length; i += 1) {
        hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
    }
    const hue = hash % 360;
    return `hsl(${hue} 70% 45%)`;
}

